export class DeviceOfflineError extends Error {
  constructor() {
    super("Device offline");
  }
}
